import { radians } from "@/core/utils/math"
import { mat4, vec2, vec4 } from "gl-matrix"

export function getCropMatrix(
	out: mat4,
	imageSize: vec2,
	crop: vec4,
	cropStraighten: number,
	flipX: boolean,
	flipY: boolean,
	orientation: number,
) {
	const straighten = radians(cropStraighten)
	const rotation = radians(orientation * 90)
	const [cx, cy, cw, ch] = crop
	const [iw, ih] = imageSize

	const mat = out

	mat4.identity(mat)

	// Set crop origin to top-left
	mat4.translate(mat, mat, [-1, -1, 0])

	// Crop
	mat4.scale(mat, mat, [1 / cw, 1 / ch, 1])
	mat4.translate(mat, mat, [cx * -2, cy * -2, 0])

	// Reset crop origin
	mat4.translate(mat, mat, [1, 1, 0])

	// Straighten
	mat4.scale(mat, mat, [1 / iw, 1 / ih, 1])
	mat4.rotateZ(mat, mat, straighten)
	mat4.scale(mat, mat, [iw, ih, 1])

	// Orientation
	mat4.rotateZ(mat, mat, rotation)

	// Flip
	mat4.scale(mat, mat, [flipX ? -1 : 1, flipY ? -1 : 1, 1])

	return mat
}

export function quantizeCrop(out: vec4, imageSize: vec2, crop: vec4) {
	const [width, height] = imageSize
	let [x, y, w, h] = crop

	x = Math.round(x * width)
	y = Math.round(y * height)
	w = Math.round(w * width)
	h = Math.round(h * height)

	w = Math.max(10, w)
	h = Math.max(10, h)

	// prettier-ignore
	return vec4.set(
		out,
		x / width,
		y / height,
		w / width,
		h / height
	)
}
